<template>
    <div class="chatContainer">
        <div class="chat" id="chatwindow">
            <div class="chatMessage" v-for="chat, idx in chatmessages" :key="idx">
                <div class="status-row">
                    <div class="date">{{chat.date}}</div>
                    <div class="sender">{{chat.playername}}</div>
                </div>
                <div class="message">{{chat.message}}</div>
            </div>
        </div>
        <div class="sendMessage">
            <input type="text" v-model="message" class="d-block w-100 mt-2" :placeholder="__('lobby.message')" v-on:keyup.enter="postMessage">
        </div>
    </div>
</template>

<script>

    export default {
        props: ['matchrequestid'],
        data() {
            return {
                message: null,
                chatmessages: [
                    {
                        date: new Date().toLocaleTimeString(),
                        playername: __("lobby.system"),
                        message: __("lobby.chatmessage1")
                    },
                    {
                        date: new Date().toLocaleTimeString(),
                        playername: __("lobby.system"),
                        message: __("lobby.chatmessage2")
                    },
                    {
                        date: new Date().toLocaleTimeString(),
                        playername: __("lobby.system"),
                        message: __("lobby.chatmessage3")
                    }
                ],
            }
        },
        mounted() {
            console.log('Chat loaded.', this.matchrequestid)

            Echo.join('matchrequests.' + this.matchrequestid)
            .here(users => {
            })
            .joining(user => {
            })
            .leaving(user => {
            })

            Echo.channel('matchrequests.' + this.matchrequestid)
            .listen('.message.created', (e) => {
                this.chatmessages.push({
                    date: new Date().toLocaleTimeString(),
                    playername: e.playername,
                    message: e.message
                })
                setTimeout(() => {
                    var div = document.getElementById('chatwindow');
                    div.scrollTop = div.scrollHeight - div.clientHeight;
                }, 0);
            })
        },
        methods: {
            postMessage() {
                axios.post("sendchatmessage", {channel: this.matchrequestid, message: this.message})
                this.message = "";
            }
        }
    }
</script>
